module.exports = __webpack_public_path__ + "img/dropdown-menu-product-1-2.0d18c9ee.png";